import React from 'react';

function HtmlAdapter(props) {
  let columnsConfig = props.settings.Configuration.columnsConfig;

  return (
    <div
      style={props.settings.Configuration.style}
      dangerouslySetInnerHTML={{
        __html:
          props.settings.Data && props.settings.Data.length
            ? props.settings.Data[0][props.settings.Configuration.key]
            : 'N/A',
      }}
    ></div>
  );
}

export default HtmlAdapter;
